<template>
  <div class="row">
    <!-- Header -->
    <div class="col-12 mb-4">
      <div class="d-flex align-items-center justify-content-between flex-wrap">
        <div class="d-flex align-items-center">
          <button @click="back" class="btn btn-outline-secondary btn-icon-text py-2 px-3 mr-3">
            <i class="mdi mdi-arrow-left mr-1"></i> {{ $t('common.back') }}
          </button>
          <div>
            <h2 class="text-white font-weight-bold mb-1">{{ $t('redeem.detailsTitle') }}</h2>
            <p class="text-muted small mb-0">{{ redeem.name || $t('redeem.detailsTitle') }}</p>
          </div>
        </div>
        <div class="d-flex align-items-center gap-2 mt-2 mt-md-0">
          <router-link :to="{ name: 'EditRedeem', params: { id: id } }" class="btn btn-primary px-3 py-2 mr-2 font-weight-bold">
            <i class="mdi mdi-lead-pencil mr-1"></i> {{ $t('common.edit') }}
          </router-link>
          <button type="button" class="btn btn-outline-danger px-3 py-2" @click="confirmDelete" :disabled="loading">
            <i class="mdi mdi-delete-outline mr-1"></i> {{ $t('common.delete') }}
          </button>
        </div>
      </div>
    </div>

    <!-- Main Card -->
    <div class="col-12 grid-margin">
      <div class="card border border-secondary">
        <div class="card-body">
          <div class="row">
            <!-- Left: Item Info -->
            <div class="col-md-7 mb-4">
              <span class="badge badge-outline-warning px-3 py-2 font-weight-bold text-uppercase mb-3 d-inline-block">
                <i class="mdi mdi-storefront-outline mr-1"></i> {{ $t('nav.rewardShop') }}
              </span>

              <h3 class="text-white font-weight-bold mb-3">{{ redeem.name }}</h3>

              <div class="p-3 bg-dark rounded border border-secondary mb-4">
                <label class="text-muted small text-uppercase font-weight-bold d-block mb-1">{{ $currentLocale === 'id' ? 'Mekanisme Penukaran' : 'Redemption Mechanism' }}</label>
                <p class="text-white mb-0 small">
                  {{ $currentLocale === 'id' ? 'Karyawan dapat menukarkan Gold yang diperoleh dari menyelesaikan quest dengan item ini melalui Player Portal. Setelah ditukarkan, notifikasi akan dikirimkan kepada tim HR/Admin untuk penyerahan benefit secara fisik atau digital.' : 'Employees can redeem Gold earned from completing quests for this item via the Player Portal. Once redeemed, a notification will be sent to the HR/Admin team for physical or digital benefit fulfillment.' }}
                </p>
              </div>

              <div class="text-muted small">
                <i class="mdi mdi-clock-outline mr-1"></i> {{ $currentLocale === 'id' ? 'Terdaftar pada' : 'Registered on' }} {{ formatDate(redeem.created_at) }}
              </div>
            </div>

            <!-- Right: Cost Card -->
            <div class="col-md-5 mb-4">
              <div class="p-4 bg-dark rounded border border-secondary text-center h-100 d-flex flex-column justify-content-center">
                <label class="text-muted small text-uppercase font-weight-bold d-block mb-2">{{ $t('redeem.costGold') }}</label>
                <div class="d-flex align-items-center justify-content-center mb-3">
                  <i class="mdi mdi-circle-multiple text-warning display-4 mr-2"></i>
                  <span class="text-warning display-4 font-weight-bold">{{ redeem.gold }}</span>
                  <span class="text-warning font-weight-bold ml-2">Gold</span>
                </div>
                <div class="badge badge-success px-3 py-2 mx-auto font-weight-medium">
                  <i class="mdi mdi-check-circle-outline mr-1"></i> {{ $currentLocale === 'id' ? 'Tersedia di Katalog Player' : 'Available in Player Catalog' }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDetailRedeem, deleteRedeem } from "../../services/redeemService";
import Swal from 'sweetalert2';
import moment from 'moment';

export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data: () => ({
    redeem: {},
    loading: false,
  }),
  methods: {
    back() {
      this.$router.go(-1);
    },
    async fetchRedeem() {
      try {
        const response = await getDetailRedeem(this.id);
        this.redeem = response.data || {};
      } catch (err) {
        console.error('Error fetching redeem detail:', err);
      }
    },
    confirmDelete() {
      Swal.fire({
        title: this.$t('redeem.confirmDelete'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#ef4444',
        cancelButtonColor: '#6b7280',
        confirmButtonText: this.$t('common.delete'),
        cancelButtonText: this.$t('common.cancel'),
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            this.loading = true;
            await deleteRedeem(this.id);
            Swal.fire({
              icon: 'success',
              title: this.$t('common.success'),
              text: this.$t('redeem.deletedSuccess'),
              confirmButtonColor: '#3b82f6'
            });
            this.$router.push('/redeem');
          } catch (err) {
            Swal.fire({
              icon: 'error',
              title: this.$t('common.error'),
              text: this.$currentLocale === 'id' ? 'Gagal menghapus item hadiah' : 'Failed to delete reward item',
            });
          } finally {
            this.loading = false;
          }
        }
      });
    },
    formatDate(date) {
      if (!date) return '-';
      return moment(date).format('DD MMM YYYY, HH:mm');
    }
  },
  mounted() {
    this.fetchRedeem();
  }
};
</script>
